/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-key */
/* eslint-disable no-else-return */
/* eslint-disable no-return-assign */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './CabSearchResults.scss';
import { MdPerson } from 'react-icons/md';
import { Carousel, Col, Row } from 'react-bootstrap';
import { TiTick } from 'react-icons/ti';
import { ImCross } from 'react-icons/im';
import {
  formatCurrency,
  formatDate,
  getNewDate,
} from '../../../shared/helper-utils/appUtils';
import AppLink from '../../../shared/components/app-link/AppLink';
import { DAY_DATE_MONTH_YEAR_VIEW_FORMAT } from '../../../shared/constants/Constants';

function SelectedCabCard({ cab, searchRequest }) {
  const [showDetails, setShowDetails] = useState(false);
  const getCancellationText = (freeCancellationAllowed) => {
    if (freeCancellationAllowed) {
      return (
        <>
          <TiTick size={30} color="green" />
          <span style={{ color: 'green' }} className="font-weight-bold fs-14">
            Free Cancellation
          </span>
        </>
      );
    } else {
      return (
        <>
          <ImCross color="red" />{' '}
          <span
            style={{ color: 'red' }}
            className="mx-2 font-weight-bold fs-14"
          >
            Non-Refundable
          </span>
        </>
      );
    }
  };
  return (
    <div className="cab-result-card p-2">
      <div className="d-flex gap-4 align-items-center">
        <div>
          <img
            src={cab.vehicleDetails.thumbNail}
            alt={cab.vehicleDetails.thumbNail}
            onError={(e) => (e.target.src = '/images/others/no-img.jpg')}
            className="cab-img"
          />
        </div>
        <div className="w-100">
          <Row className="align-items-center">
            <Col lg={3} md={3} sm={3} xs={12}>
              <div className="fw-600 fs-20">{cab.vehicleDetails.name}</div>
              <div className="service-type fs-12 d-inline-block">
                {cab.vehicleDetails.serviceType}
              </div>
              <div className="d-flex align-items-center mt-2">
                <MdPerson />
                <div className="fs-12">
                  {cab.vehicleDetails.seatCapacity} persons
                </div>
              </div>
            </Col>
            <Col lg={3} md={3} sm={3} xs={6}>
              <div className="fw-600 fs-10">Journey Date</div>
              <div className="fs-14">
                {formatDate(
                  getNewDate(searchRequest.onwordDetails.journeyDate),
                  DAY_DATE_MONTH_YEAR_VIEW_FORMAT,
                )}
              </div>
            </Col>
            <Col lg={4} md={4} sm={4} xs={6}>
              <div>
                {getCancellationText(
                  cab.cancellationPolicy.freeCancellationAllowed,
                )}
              </div>
            </Col>
            <Col lg={2} md={2} sm={2} xs={12}>
              <div className="d-flex flex-column align-items-end justify-content-center">
                <div className="fw-600 price-text">
                  {formatCurrency(cab.nextraTotalPrice)}
                </div>
                <div>
                  <AppLink
                    linkText="View Details"
                    className="fs-14"
                    onClick={() => setShowDetails(!showDetails)}
                    variant="primary"
                  />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {showDetails && (
        <div className="cab-details p-2 mt-4">
          <Row>
            <Col lg={6} md={6} sm={6} xs={12}>
              <Carousel>
                {cab.vehicleDetails.images?.length > 0 &&
                  cab.vehicleDetails.images.map((img, index) => (
                    <Carousel.Item>
                      <img
                        src={img.url}
                        alt={`${img.type} - ${index + 1}`}
                        className="d-block w-100"
                      />
                    </Carousel.Item>
                  ))}
              </Carousel>
            </Col>
            <Col lg={6} md={6} sm={6} xs={12}>
              <div className="fw-600 fs-16 mb-2">Cancellation Policy</div>
              <ul>
                {cab.cancellationPolicy.policies.length > 0 &&
                  cab.cancellationPolicy.policies.map((policy) => (
                    <li
                      className="fs-14"
                      dangerouslySetInnerHTML={{ __html: policy }}
                    />
                  ))}
              </ul>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}
SelectedCabCard.propTypes = {
  cab: PropTypes.object.isRequired,
  searchRequest: PropTypes.object.isRequired,
};
export default SelectedCabCard;
